export default {
    "login_button_text": "Login",
    "register_button_text": "Register Now",
    "footerText": "Have any questions? Find answers by asking Hello Aldar | Your 24/7 virtual assistant for enquiries.",
    "footerTextSecondLine": "You can also raise and track your requests anytime on Live ALDAR Mobile App, or phone: 800-ALDAR (25327) or +971 2 672 5327",
    "privacy_policy": "Privacy policy"
}